(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function parseProduct(card) {
    var script = card.querySelector('[data-aspyr-shop-fit-json]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (error) { return null; }
  }

  function selectedOptions(card) {
    return Array.prototype.map.call(card.querySelectorAll('[data-aspyr-shop-fit-option]'), function (group) {
      var selected = group.querySelector('[data-aspyr-shop-fit-value].is-selected');
      return selected ? selected.dataset.aspyrShopFitValue : '';
    });
  }

  function matchingVariant(product, options) {
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find(function (variant) {
      return variant.options.every(function (value, index) { return String(value) === String(options[index]); });
    }) || null;
  }

  function optionCanResolve(product, selected, optionIndex, value, allowUnavailable) {
    return product.variants.some(function (variant) {
      if ((!allowUnavailable && variant.available === false) || String(variant.options[optionIndex]) !== String(value)) return false;
      return variant.options.every(function (variantValue, index) {
        return index === optionIndex || !selected[index] || String(selected[index]) === String(variantValue);
      });
    });
  }

  function updateImage(card, product, variant) {
    var image = card.querySelector('[data-aspyr-shop-fit-image]');
    if (!image) return;
    var source = variant && variant.featured_image && variant.featured_image.src;
    if (!source && product.featured_image) {
      source = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
    }
    if (!source) return;
    image.src = source.indexOf('?') > -1 ? source + '&width=240' : source + '?width=240';
    image.removeAttribute('srcset');
  }

  function updateCard(card) {
    var product = card._aspyrShopFitProduct || (card._aspyrShopFitProduct = parseProduct(card));
    if (!product) return null;

    var options = selectedOptions(card);
    var hasOptionGroups = card.querySelectorAll('[data-aspyr-shop-fit-option]').length > 0;
    var variant = hasOptionGroups ? matchingVariant(product, options) : product.variants[0];
    var preorder = card.dataset.preorder === 'true';
    var available = !!(variant && (variant.available || preorder));
    var selected = card.dataset.selected === 'true';
    var itemDiscount = Math.max(0, Math.min(50, Number(card.dataset.discountPercent || 0)));
    var displayPrice = variant ? Math.round(Number(variant.price || 0) * (100 - itemDiscount) / 100) : 0;

    card.dataset.variantId = variant ? variant.id : '';
    card.dataset.price = displayPrice;
    card.dataset.available = available ? 'true' : 'false';
    card.classList.toggle('is-selected', selected);

    var toggle = card.querySelector('[data-aspyr-shop-fit-toggle]');
    if (toggle) toggle.setAttribute('aria-pressed', selected ? 'true' : 'false');

    var price = card.querySelector('[data-aspyr-shop-fit-price]');
    var compare = card.querySelector('[data-aspyr-shop-fit-compare]');
    if (price && variant) price.textContent = formatMoney(displayPrice);
    if (compare && variant) {
      var comparison = itemDiscount > 0 ? Number(variant.price || 0) : Number(variant.compare_at_price || 0);
      var hasCompare = comparison > displayPrice;
      compare.textContent = hasCompare ? formatMoney(comparison) : '';
      compare.hidden = !hasCompare;
    }

    var status = card.querySelector('[data-aspyr-shop-fit-status]');
    if (status) {
      status.textContent = preorder
        ? 'Pre-order · Estimated 45–60 day delivery'
        : (available ? 'Ready to ship' : 'Unavailable');
      status.classList.toggle('is-unavailable', !available);
    }

    Array.prototype.forEach.call(card.querySelectorAll('[data-aspyr-shop-fit-option]'), function (group) {
      var optionIndex = Number(group.dataset.aspyrShopFitOption);
      Array.prototype.forEach.call(group.querySelectorAll('[data-aspyr-shop-fit-value]'), function (button) {
        button.classList.toggle('is-unavailable', !optionCanResolve(product, options, optionIndex, button.dataset.aspyrShopFitValue, preorder));
      });
    });

    if (variant) updateImage(card, product, variant);
    return variant;
  }

  function fitState(section) {
    var selectedCards = Array.prototype.filter.call(section.querySelectorAll('[data-aspyr-shop-fit-product]'), function (card) {
      return card.dataset.selected === 'true';
    });
    var variants = selectedCards.map(updateCard);
    var available = selectedCards.length > 0
      && variants.every(function (variant) { return !!variant; })
      && selectedCards.every(function (card) { return card.dataset.available === 'true'; });
    var original = variants.reduce(function (sum, variant) { return sum + (variant ? Number(variant.price || 0) : 0); }, 0);
    var itemAdjusted = selectedCards.reduce(function (sum, card) { return sum + Number(card.dataset.price || 0); }, 0);
    var discount = Math.max(0, Math.min(40, Number(section.dataset.discountPercent || 0)));
    var total = Math.round(itemAdjusted * (100 - discount) / 100);
    return { cards: selectedCards, variants: variants, available: available, original: original, total: total };
  }

  function updateFit(section) {
    Array.prototype.forEach.call(section.querySelectorAll('[data-aspyr-shop-fit-product]'), updateCard);
    var state = fitState(section);
    var button = section.querySelector('[data-aspyr-shop-fit-add]');
    var label = section.querySelector('[data-aspyr-shop-fit-add-label]');
    var total = section.querySelector('[data-aspyr-shop-fit-total]');

    if (button) button.disabled = !state.available;
    if (label) {
      label.textContent = state.cards.length
        ? (section.dataset.buttonText || label.dataset.defaultLabel || label.textContent)
        : 'SELECT ITEMS TO ADD';
    }
    if (total) total.textContent = state.cards.length ? '— ' + formatMoney(state.total) : '';
    section._aspyrShopFitState = state;
  }

  function showError(section, message) {
    var error = section.querySelector('[data-aspyr-shop-fit-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function addFit(section) {
    updateFit(section);
    var state = section._aspyrShopFitState;
    var button = section.querySelector('[data-aspyr-shop-fit-add]');
    var label = section.querySelector('[data-aspyr-shop-fit-add-label]');
    if (!state || !state.available || !button || button.disabled) return;

    var originalLabel = label ? label.textContent : '';
    showError(section, '');
    button.disabled = true;
    button.classList.add('is-loading');
    if (label) label.textContent = 'ADDING THE FIT';

    var items = state.variants.map(function (variant, index) {
      var card = state.cards[index];
      var properties = {
        '_aspyr_bundle_id': section.dataset.fitId,
        '_aspyr_bundle_name': section.dataset.fitName || 'SHOP THE FIT',
        '_aspyr_bundle_component': String(index + 1)
      };
      if (card.dataset.preorder === 'true') {
        properties['Pre-Order'] = card.dataset.preorderMessage || 'ESTIMATED DELIVERY: 45–60 DAYS';
        properties['_Preorder'] = 'true';
        properties['_Original product title'] = card.dataset.originalProductTitle || '';
        properties['_Original product URL'] = card.dataset.originalProductUrl || '';
      }
      if (Number(card.dataset.discountPercent || 0) > 0) {
        properties['_Aspyr displayed item discount'] = card.dataset.discountPercent + '%';
      }
      return {
        id: Number(variant.id),
        quantity: 1,
        properties: properties
      };
    });

    fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok || payload.status === 422) throw payload;
          return payload;
        });
      })
      .then(function (added) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: added, addToCartBtn: button } }));
      })
      .catch(function (error) {
        showError(section, error.description || error.message || 'The selected fit could not be added. Check the selected sizes.');
      })
      .finally(function () {
        button.classList.remove('is-loading');
        if (label) label.textContent = originalLabel;
        updateFit(section);
      });
  }

  function initFit(section) {
    if (section.dataset.aspyrShopFitReady === 'true') return;
    section.dataset.aspyrShopFitReady = 'true';
    var label = section.querySelector('[data-aspyr-shop-fit-add-label]');
    if (label) {
      label.dataset.defaultLabel = label.textContent.trim();
      section.dataset.buttonText = label.dataset.defaultLabel;
    }

    section.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-aspyr-shop-fit-toggle]');
      if (toggle && section.contains(toggle)) {
        var card = toggle.closest('[data-aspyr-shop-fit-product]');
        if (card.dataset.locked === 'true') return;
        card.dataset.selected = card.dataset.selected === 'true' ? 'false' : 'true';
        showError(section, '');
        updateFit(section);
        return;
      }

      var option = event.target.closest('[data-aspyr-shop-fit-value]');
      if (option && section.contains(option)) {
        var group = option.closest('[data-aspyr-shop-fit-option]');
        Array.prototype.forEach.call(group.querySelectorAll('[data-aspyr-shop-fit-value]'), function (candidate) {
          var selected = candidate === option;
          candidate.classList.toggle('is-selected', selected);
          candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        showError(section, '');
        updateFit(section);
        return;
      }

      var add = event.target.closest('[data-aspyr-shop-fit-add]');
      if (add && section.contains(add)) addFit(section);
    });

    updateFit(section);
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-aspyr-shop-fit]'), initFit);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) { init(event.target); });
})();
